export default __webpack_public_path__ + "static/media/client_img4.791656a6.png";